import axios from 'axios'

import { handleRequestError } from './request'

export const REQUEST_TAX_RETURN_POTENTIAL_DEDUCTIONS = 'REQUEST_TAX_RETURN_POTENTIAL_DEDUCTIONS'
export const RECEIVE_TAX_RETURN_POTENTIAL_DEDUCTIONS = 'RECEIVE_TAX_RETURN_POTENTIAL_DEDUCTIONS'

export const receiveDeductions = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_TAX_RETURN_POTENTIAL_DEDUCTIONS, data })
}

export const requestTaxReturnDeductions = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_TAX_RETURN_POTENTIAL_DEDUCTIONS, data: { taxReturnId } })

    return axios
        .get(`/taxreturns/${taxReturnId}/deductions`)
        .then((response) => {
            const deductions = response?.data || {}
            dispatch(receiveDeductions({ deductions, fetchSuccessful: true }))
            return deductions
        })
        .catch((error) => {
            dispatch(receiveDeductions({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}
